import { gu_deepCopy } from '@utils/general-util';

import { fetchPixelPostbackSettings } from '../slice/pixel-postback-slice';

export const fetchPixelPostbackSettingAction = (args) => {
    return (dispatch) => {
        return dispatch(fetchPixelPostbackSettings(args))
            .then((res) => gu_deepCopy(res));
    };
};
